<template>
  <div class="homepage">
    <span v-show="false">
      <notice-list :type="'通知公告'" class="noticeList" icon="pull-request"></notice-list>    
    </span>
    <notice-list :type="'操作指南'" class="noticeList" icon="pull-request"></notice-list>    
    <notice-list :type="'常见问答'" class="noticeList" icon="help-circled"></notice-list>
    <Row type="flex">
      <Col span="14" style="width: 60%;margin-right:0.5%">
        <quick-entry 
          @viewModal="viewModal"
          title="客户管理"
          icon="android-person"
          size="26"
          :list="clientManage"
          :margin="true">
        </quick-entry>
        <quick-entry 
          @viewModal="viewModal"
          title="项目流程(标前)"
          icon="arrow-swap"
          size="26"
          :list="flowList_before">
        </quick-entry>
        <quick-entry 
          @viewModal="viewModal"
          title="项目流程(开标及标后)"
          icon="arrow-swap"
          size="26"
          :list="flowList_after">
        </quick-entry>
      </Col>
      <Col span="10" style="width: 39.5%">
        <quick-entry 
          @viewModal="viewModal"
          title="流程审批"
          icon="android-checkbox"
          size="26"
          :list="flowAuditing"
          :margin="true">
        </quick-entry>
        <quick-entry 
          @viewModal="viewModal"
          title="财务类"
          icon="social-yen"
          size="26"
          :list="finance"
          :margin="true">
        </quick-entry>
        <quick-entry 
          @viewModal="viewModal"
          title="业绩报表"
          icon="stats-bars"
          size="26"
          :list="quickEntryList"
          :margin="true">
        </quick-entry>
      </Col>
    </Row>
    <Row>
      <Col span="6" style="width: 30%;margin-right:0.5%">
        <quick-entry 
          @viewModal="viewModal"
          title="项目管理"
          icon="android-settings"
          size="26"
          :list="projectManage"
          :margin="true">
        </quick-entry>
      </Col>
      <Col span="6" style="width: 29.5%;margin-right:0.5%">
        <quick-entry 
          @viewModal="viewModal"
          title="项目汇总"
          icon="folder"
          size="26"
          :list="history"
          :margin="true">
        </quick-entry>
      </Col>
      <Col span="10" style="width: 39.5%">
        <quick-entry 
          @viewModal="viewModal"
          title="其他"
          icon="social-buffer"
          size="26"
          :list="otherList"
          :margin="true">
        </quick-entry>
      </Col>
    </Row>
    <Modal width="98%" height="95%" class-name="homepage-modal" v-model="functionModal" :title="functionTitle">
      <!-- 报表显示弹窗 -->
      <Layout v-show="!viewComponent">
        <!-- 业绩类显示左侧导航栏 -->
        <Sider hide-trigger width="300" v-show="functionTitle.indexOf('业绩')!==-1">
          <Tree :data="fullList" @on-select-change="sideSelect"></Tree>
        </Sider>
        <Layout>
          <Content class="content">
            <iframe style="width:100%;height:100%;border:0;" :src="functionUrl"></iframe>
          </Content>
        </Layout>
      </Layout>
      <!-- 组件显示 -->
      <div style="padding:20px;height:100%;overflow:auto">
        <component :is="componentView" v-show="viewComponent" :confirm="componentView == 'npform2'"></component>
      </div>
      <div slot="footer"></div>
    </Modal>
    <!-- 用户地区选择 -->
    <Modal
      v-model="newUserModal"
      :closable="false"
      class-name="newUserModal"
      title="欢迎新用户"
      :mask-closable="false">
      <h4 style="margin-bottom: 10px">该账号为新用户，请选择所属地区：</h4>
      <RadioGroup v-model="district" type="button">
        <Radio :label="item.name" v-for="item in districtList" :key="item.id"></Radio>
      </RadioGroup>
      <div slot="footer">
        <Button type="primary" @click="selectDistrict">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="showNotice"
      title="系统升级通知"
      width="800px"
      :styles="{ top: '160px' }"
    >
      <h3 style="font-size: 16px;">各位同事：</h3>
      <p style="text-indent: 2em;margin-top:8px;font-size:16px;">大家好！2022年1月17日起，采联业务系统3.0将逐渐升级成为采联业务系统4.0，附件为采联业务系统4.0简要操作指南，请大家查阅了解新系统使用及操作。1月19日周三将限制立项功能及文件编制功能（原3.0项目不影响），届时请使用新系统立项及进行相关操作。若系统使用中有问题可联系采联业务系统服务号咨询。</p>
      <div style="font-size:16px;margin-top: 8px;">附件：<a href="https://choicelink-public.oss-cn-shenzhen.aliyuncs.com/171b6b57042f4c1fb090e8cd6618f9bf.docx">采联业务系统4.0操作文档</a></div>
    </Modal>
    <span v-if="false">{{todoCount}}</span>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import { formatDate } from '@/lib/tool'
import ajax from '@/lib/ajax'
import userAjax from '@/lib/userAjax'
import requestUrls from '@/lib/requestUrls'
import reportUrls from '@/lib/reportUrls'
import NoticeList from './noticeList'   // 通知公告
import quickEntry from './quickEntry'  // 供应商报名
import examineEnroll from '@/views/nprojecttable/examineEnroll/examineEnroll'  // 报名审核
import biddingConfirm from '@/views/projectCenter/biddingConfirm/biddingConfirm'  // 中标确认
import npform from '@/views/workflow/nproject/npform2'  // 项目立项
import npform2 from '@/views/workflow/nproject/npform2'  // 立项确认
import evaluationBid from '@/views/evaluationBid'  // 电子评标
import documenting from '@/views/documentation/documenting'  // 文件编制
import documentSummary from '@/views/documentSummary/documentSummary'   // 文件汇总
import projectModify from '@/views/projectCenter/projectModify/projectModify'  // 项目编辑
import depositProject from '@/views/deposit/depositProject'  // 领取保证金（广发）
import cancelProject from '@/views/projectCenter/cancelProject/cancelProject'  // 项目取消
import expertFee from '@/views/expertFee/expertFee'  // 专家费借支
import expertFeeArgu from '@/views/expertFeeArgu/expertFeeArgu'  // 专家费借支（其他）
import auditingFile from '@/views/documentation/auditingFile/auditingFile'  // 文件审核
import militaryExamine from '@/views/militaryExamine/militaryExamine'  // 保密办项目审查
import serviceCharge from '@/views/serviceCharge/serviceCharge'  // 服务费
import commissionSystem from '@/views/commission/commissionSystem/commissionSystem'  // 提成系统
import biddingManagement from '@/views/biddingManagement/biddingManagement'  // 投标管理
import purchaserVisitList from '@/views/purchaserInfo/purchaserVisitList'  // 采购人拜访记录
import purchaserArchives from '@/views/purchaserInfo/archives/purchaserArchives'  // 采购人档案
import depositBackFlow from '@/views/depositBackFlow/depositBackApply'  // 退保申请
import depositApplyFlow from '@/views/depositBackFlow/depositApplyFlow'  // 退保审核
import depositDetail from '@/views/depositDetail/depositDetail'  // 保证金明细
import projectFlow from '@/views/projectFlow/projectFlow'  // 项目一览
import room from '@/views/room/roomIndex'
import util from "@/lib/util"

const apiKey = '6dc99789-2448-4f11-9bfa-e6600366c6cb'
export default {
  name: 'home',
  components: {
    NoticeList,  // 通知公告
    examineEnroll,  // 供应商报名
    biddingConfirm,  // 中标确认
    npform,  // 项目立项
    evaluationBid,  // 电子评标
    documenting,  // 文件编制
    documentSummary,  // 文件汇总
    projectModify,  // 项目编辑
    quickEntry,  // 快速入口
    depositProject,
    cancelProject,
    expertFee,
    expertFeeArgu,
    auditingFile,
    militaryExamine,
    serviceCharge,
    commissionSystem,
    biddingManagement,
    purchaserVisitList,
    purchaserArchives,
    depositBackFlow,
    depositApplyFlow,
    npform2,
    room,
    depositDetail,
    projectFlow
  },
  data() {
    return {
      showNotice: true,
      functionModal: false,
      functionTitle: '快速功能入口',
      functionUrl: '',
      quickEntryList: [],
      viewComponent: false,
      componentView: '',
      search: '',
      fullList: [],
      '集团业绩': {
        title: "集团业绩",
        children: [
          {
            title: "汇总",
            children: [
              {
                title: "项目收入一览表"
              }
            ]
          },
          {
            title: "明细",
            children: [
              {
                title: "集团服务费明细表",
              },
              {
                title: "集团标书款明细表",
              },
              {
                title: "集团预计服务费明细表",
              },
              {
                title: "集团应收款(AR)明细表",
              },
            ]
          },
          {
            title: "提成",
            children: [
              {
                title: "集团提成发放",
              },
              {
                title: "客户经理业绩完成情况",
              }
            ]
          },
          {
            title: "排名",
            children: [
              {
                title: "集团分公司业绩排名"
              },
              {
                title: "集团个人业绩排名(线上)"
              },
              {
                title: "集团个人业绩排名(线下)",
              }
            ]
          },
        ]
      },
      '分公司业绩': {
        title: "分公司业绩",
        children: [
          {
            title: "汇总",
            children: [
              {
                title: "分公司项目收入一览表"
              }
            ]
          },
          {
            title: "明细",
            children: [
              {
                title: "线上",
                children: [
                  {
                    title: "分子公司个人业绩明细"
                  },
                  {
                    title: "分子公司线上应收款明细表"
                  },
                  {
                    title: "分子公司线上服务费明细表"
                  },
                ]
              },
              {
                title: "线下",
                children: [
                  {
                    title: "分公司服务费明细表"
                  },
                  {
                    title: "分公司标书款明细表"
                  },
                  {
                    title: "分公司预计服务费明细表"
                  },
                  {
                    title: "分公司应收款(AR)明细表"
                  },
                ]
              }
            ]
          },
          {
            title: "提成",
            children: [
              {
                title: "分公司提成发放",
              },
              {
                title: "分公司客户经理业绩完成情况",
              }
            ]
          },
          {
            title: "排名",
            children: [
              {
                title: "分公司个人业绩排名(线上)"
              },
              {
                title: "分公司个人业绩排名(线下)"
              }
            ]
          }
        ]
      },
      '个人业绩': {
        title: "个人业绩",
        children: [
          {
            title: "汇总",
            children: [
              {
                title: "个人项目收入一览表"
              }
            ]
          },
          {
            title: "明细",
            children: [
              {
                title: "线上",
                children: [
                  {
                    title: "个人线上应收款明细表"
                  },
                  {
                    title: "个人线上服务费明细表"
                  }
                ]
              },
              {
                title: "线下",
                children: [
                  {
                    title: "个人服务费明细表"
                  },
                  {
                    title: "个人标书款明细表"
                  },
                  {
                    title: "个人预计服务费明细表"
                  },
                  {
                    title: "个人在应收款(AR)明细表"
                  }
                ]
              }
            ]
          },
          {
            title: "提成",
            children: [
              {
                title: "个人线上提成明细表",
              },
              {
                title: "个人提成发放",
              },
              {
                title: "客户经理业绩完成情况",
              }
            ]
          }
        ]
      },
      list: [],
      flowList_before: [],
      flowList_after: [],
      flowAuditing: [],
      finance: [],
      projectManage: [],
      clientManage: [],
      otherList: [],
      history: [],
      kbrl: {
        // iconName: "开标日历表.png",
        iconUrl: "icon/aYloYK128U.png",
        reportSysUrl: "/WebReport/ReportServer?reportlet=cailian%2F%5B4f1a%5D%5B8bae%5D%5B5ba4%5D%5B5b89%5D%5B6392%5D%2FKaiBiaoPlan.cpt",
        title: "开标日历表"
      }, // 开标日历
      lsxm: {
        // iconName: "历史项目.png",
        iconUrl: "icon/*SbKWh0v*M.png",
        reportSysUrl: "/WebReport/ReportServer?reportlet=cailian%2FGD%2FProject%2Fmain.cpt",
        title: "历史项目",
        tips: '已结项及已开评标完成项目，包含文件，报名等详细信息'
      },// 历史项目
      xmhz: {
        // iconName: "按项目导出.png",
        iconUrl: "icon/mac7jtEGra.png",
        reportSysUrl: "/WebReport/ReportServer?reportlet=cailian%2FGD%2FProjectOut.cpt",
        title: "按项目导出",
        tips: '按项目形式导出所有项目，只包含基本项目信息'
      }, // 项目汇总
      bzhz: {
        // iconName: "按包组导出.png",
        iconUrl: "icon/mac7jtEGra.png",
        reportSysUrl: "/WebReport/ReportServer?reportlet=cailian%2FGD%2FBZOut.cpt",
        title: "按包组导出",
        tips: '按包组形式导出所有项目，包含包组交易情况信息'
      },// 包组汇总
      xmyl: {
        title: "项目一览",
        name: "projectFlow",
        url: "projectFlow/"
      },// 项目一览
      arrow: '',
      newUserModal: false,
      district: '',
      districtList: [],
      flag: true
    }
  },
  beforeCreate () {
    if (!this.$store.state.session.user.accountStatus) {
      this.$Message.success('请设置密码')
      this.$router.push({ name: "forgetPwd" })
    }
  },
  async mounted() {
    // 新用户地区选择
    this.newUserModal = this.user.selectDistrict ? false : true
    let rep = await ajax.get(requestUrls.CLDistrict.GetListWithoutRole)
    this.districtList = rep.data.result.items
    this.flowList_after.splice(0, 0, this.kbrl)  // 开标日历
    this.history.splice(1, 0, this.lsxm)  // 历史项目
    this.history.splice(1, 0, this.bzhz)  // 包租汇总
    this.history.splice(1, 0, this.xmhz)  // 项目汇总
    this.projectManage.splice(1, 0, this.xmyl)  // 项目一览
    this.flowAuditing.splice(0, 0, this.wjsh)  // 文件审核
    if (this.editPermission) this.flowAuditing.splice(2, 0, this.bmbsh)  // 保密办审核(权限)
    // 角色报表权限
    ajax.get(requestUrls.AbpReportSysSetting.GetListByRoleId, {
      params: {
        roleIds: this.$store.state.session.roleIds
      },
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      }
    }).then(res => {
      let data = res.data.result.items
      data.forEach(item => {
        this.quickEntryList.push(item)
        this.fullList.push(this[item.title])
      })
    })
    // 待办数
    let todoCount = this.$store.state.todoCount
    this.wjsh.count = todoCount.fileCount
    this.bmbsh.count = todoCount.secretCount
    this.tbsh.count = todoCount.depositCount
    this.commissionSystem.count = todoCount.QRCount + todoCount.FQCount + todoCount.FPCount + todoCount.ZJQRCount + todoCount.ZXQRCount
    if (this.$store.state.app['menuData'].length !== 0) {
      let menu = await this.$store.state.app['menuData']
      this.quickMenu(menu,todoCount)
    } else {
      ajax.get('/api/services/app/AbpMenu/GetAllMenusByRoles', {
        params: {
          roles: this.$store.state.session.roleIds
        },
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      }).then(async(res) => {
        let menu = await res.data.result.items
        this.quickMenu(menu,todoCount)
      })
    }
  },
  computed: {
    editPermission() {
      // 获取用户角色信息
      return this.$store.getters["session/hasRoles"]("保密办")
    },
    enrollPermission() {
      return this.$store.getters["session/hasRoles"]("报名审核")
    },
    user () {
      let user = this.$store.state.session.user
      let roles = this.$store.state.session.roleNames
      let roleStr = ''
      if (roles.length > 0) {
        roles.forEach(role => {
          roleStr += `${role},`
        })
      }
      roleStr = roleStr.slice(0, -1)
      this.lsxm.reportSysUrl = `/WebReport/ReportServer?reportlet=cailian%2FGD%2FProject%2Fmain.cpt&role=${roleStr}`
      return user
    },
    wjsh() {
      return  {
        title: "文件审核",
        name: "auditingFile",
        url: "auditingFile/",
        count: this.$store.state.todoCount.fileCount
      }
    },
    bmbsh() {
      return {
        title: "保密办审核",
        name: "militaryExamine",
        url: "militaryExamine/",
        count: this.$store.state.todoCount.secretCount
      }
    },
    tbsh() {
      return {
        count: this.$store.state.todoCount.depositCount,
        name: "depositBackFlow",
        title: "退保审核",
        url: "depositApplyFlow/"
      }
    },
    commissionSystem() {
      let todoCount = this.$store.state.todoCount
      return {
        title: "提成系统",
        parentId: "deebd3f0-8a2d-41d6-810a-fb451bd59204",
        url: "commissionSystem/",
        count: todoCount.QRCount + todoCount.FQCount + todoCount.FPCount + todoCount.ZJQRCount + todoCount.ZXQRCount
      }
    }
  },
  methods: {
    sideSelect(val) {
      if (val[0]&&!val[0].children) {
        let url = reportUrls[val[0].title]
        if (url.indexOf('个人业绩一览') !== -1) {
          this.functionUrl = `${reportUrls.baseUrl}${reportUrls[val[0].title]}${this.user.name}`
        } else if (url.indexOf('分公司业绩一览') !== -1) {
          this.functionUrl = `${reportUrls.baseUrl}${reportUrls[val[0].title]}${this.user.selectDistrict}`
        } else {
          this.functionUrl = `${reportUrls.baseUrl}${reportUrls[val[0].title]}`
        }
      } else {
        // 点击节点名称展开/收起子节点
        if (val[0]) {
          setTimeout(() => {
            let title = document.querySelector('span.ivu-tree-title-selected')
            this.arrow = title.previousElementSibling
            this.arrow.click()
          },0)
        } else {
          this.arrow.click()
        }
      }
    },
    async quickMenu(menu,todoCount) {       // 当前用户是否有菜单权限
      if(!this.flag) return
      menu.forEach(item => {
        switch(item.displayName) {
          // 客户管理
          case '投标管理':
            this.$set(item,'title','投标管理')
            item.url = 'biddingManagement/'
            this.clientManage.splice(0, 0, item)
          break
          case '采购人拜访记录':
            this.$set(item,'title','采购人拜访')
            this.clientManage.splice(1, 0, item)
          break
          case '采购人档案':
            this.$set(item,'title','采购人档案')
            this.clientManage.splice(2, 0, item)
          break
          case '项目立项':
            this.$set(item,'title','项目立项')
            this.clientManage.splice(3, 0, item)
          break
          // 项目流程（标前）
          case '编制及挂网':
            this.$set(item,'title','编制挂网')
            this.flowList_before.splice(0, 0, item)
          break
          case '报名审核':
            this.$set(item,'title','报名审核')
            if (this.enrollPermission) this.$set(item,'count',todoCount.enrollCount)
            this.flowList_before.splice(1, 0, item)
          break
          case '领取保证金（广发）':
            this.$set(item,'title','领取保证金')
            this.flowList_before.splice(2, 0, item)
          break
          case '项目取消':
            this.$set(item,'title','项目取消')
            this.flowList_before.splice(3, 0, item)
          break
          // 项目流程（开标及标后）
          case '电子评标':
            this.$set(item,'title','电子评标')
            this.flowList_after.splice(1, 0, item)
          break
          case '中标确认及打印':
            this.$set(item,'title','中标确认')
            this.flowList_after.splice(2, 0, item)
          break
          case '文件汇总':
            this.$set(item,'title','文件汇总')
            this.flowList_after.splice(3, 0, item)
          break
          case '退保申请':
            this.$set(item,'title','退保申请')
            this.flowList_after.splice(4, 0, item)
            this.flowAuditing.splice(3, 0, this.tbsh)
          break
          // 流程审批
          case '项目立项确认':
            this.$set(item,'title','立项确认')
            this.$set(item,'count',todoCount.projectCount)
            this.flowAuditing.splice(1, 0, item)
          break
          case '项目编辑':
            this.$set(item,'title','项目编辑')
            this.projectManage.splice(0, 0, item)
          break
          // 财务类
          case '服务费':
            this.$set(item,'title','服务费')
            this.finance.splice(0, 0, item)
          break
          case '专家费借支':
            this.$set(item,'title','专家费借支')
            this.$set(item,'count',todoCount.expertFeeCount)
            this.finance.splice(1, 0, item)
          break
          case '专家费借支（其他）':
            this.$set(item,'title','专家费借支(其他)')
            this.$set(item,'count',todoCount.expertOtherCount)
            this.finance.splice(2, 0, item)
          break
          case '保证金明细':
            this.$set(item,'title','保证金明细')
            this.finance.splice(2, 0, item)
          break
          // 其他
          case '会议室（非开标）':
            this.$set(item,'title','会议室(非开标)')
            this.otherList.push(item)
            break
        }
      })
      this.otherList.push(this.commissionSystem)
      this.flag = false
    },
    viewModal(entry) {
      const disEntryArr = ["examineEnroll","roomindex","purchaserVisitList","documenting","expertFee","expertFeeArgu","cancelProject","projectModify","depositProject"]
      if(disEntryArr.includes(entry.name)) return this.$Message.info(`该功能已关闭，请到4.0系统使用${entry.title}`)
      if(['历史项目','按项目导出','按包组导出'].includes(entry.title)) return this.$Message.info(`该功能已关闭，请到4.0系统使用${entry.title}`)
      if (entry.reportSysUrl) {
        this.functionTitle = entry.title
        switch (entry.title) {
          case '个人业绩':
            this.functionUrl = `${reportUrls.baseUrl}${reportUrls['个人项目收入一览表']}${this.user.name}`
            break
          case '分公司业绩':
            this.functionUrl = `${reportUrls.baseUrl}${reportUrls['分公司项目收入一览表']}${this.user.selectDistrict}`
            break
          case '集团业绩':
            this.functionUrl = `${reportUrls.baseUrl}${reportUrls['项目收入一览表']}`
            break
          default:
            this.functionUrl = `${requestUrls.reportUrl}${entry.reportSysUrl}&userName=${this.user.name}&userId=${this.user.id}`
        }
        this.functionModal = true
        this.viewComponent = false
      } else {
        this.functionTitle = entry.title
        // 组件名：截取url / 前的内容！！！
        this.componentView = entry.url.slice(0,-1)
        this.functionModal = true
        this.viewComponent = true
      }
    },
    selectDistrict() {
      if (!this.district) {
        this.$Message.error('请选择地区！')
        return
      }
      userAjax.post(requestUrls.User.BatchUpdateDistrict, [{
        userId: this.user.id,
        districts: [ this.district ]
      }]).then(() => {
        this.newUserModal = false
        this.$Message.success('设置成功，请设置密码')
        this.$store.commit("app/logout", this)
        util.abp.auth.clearToken()
        this.$router.push({ name: "forgetPwd" })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.homepage {
  min-width: 1200px;
  .noticeList {
    width: 49.75%;
    display: inline-block;
    vertical-align: text-bottom;
    & + .noticeList {
      margin-left: 0.5%;
    }
  }
}
/deep/.homepage-modal {
  .ivu-modal {
    top: 20px;
    height: 95%;
    .ivu-modal-content {
      height: 100%;
    }
    .ivu-modal-body {
      height: 90%;
      overflow: hidden;
      padding: 0;
    }
    .ivu-layout-sider {
      padding: 20px;
      background-color: #fff;
      overflow: auto;
    }
    .ivu-layout {
      height: 100%;
      overflow: hidden;
    }
    .content {
      height: 100%;
      background-color: #fff;
      font-size: 14px;
      border-left:1px solid #e9eaec;
      overflow: hidden;
    }
    .ivu-tree li ul {
      padding-left: 14px;
    }
    .ivu-tree-title {
      font-size: 14px;
    }
  }
}
.newUserModal .ivu-radio-wrapper {
  margin: 2px;
}
</style>